import { createServerFn } from "@tanstack/react-start";

/** حالة التسجيل الجديد عبر UpPromote للواجهة العامّة. تفشل مقفولة. */
export const getUpPromoteJoinStatus = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ enabled: boolean }> => {
    const { isUpPromoteJoinEnabled } = await import("@/lib/server/upPromoteJoinFlag");
    return { enabled: await isUpPromoteJoinEnabled("getUpPromoteJoinStatus") };
  },
);
